<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiArchiveOutline } from "@mdi/js"
  import type { CustomerRow } from "../../_shared/_logic/customers-table-contract"
  import { archivePresentation } from "../../../../../../../../_shared/_logic/archive-presentation"

  let { row }: { row: CustomerRow } = $props()

  const archiveTooltip = $derived.by(() => {
    if (!row.customer.archived_at) return row.identityTooltip

    return `${row.identityTooltip}\n${archivePresentation(row.customer.archived_at, row.customer.archive_reason)}`
  })
</script>

<StatusTag
  variant="neutral"
  size="sm"
  class="identity-tag"
  label={row.identityLabel || "Unbekannter Kontakt"}
  icon={row.customer.archived_at ? mdiArchiveOutline : row.identityIcon}
  color={row.customer.archived_at ? "#7b8794" : row.identityColor}
  tooltipContent={archiveTooltip}
/>

<style lang="less">
  :global(.identity-tag) {
    max-width: min(100%, 18rem);
  }
</style>
